import React, { useEffect, useState } from 'react';
import { Input } from 'antd';

import FormError from 'components/molecules/form-error';
import { useTheme } from 'common/styling/theme';
import { processAndValidateUnitElements } from 'common/utils/send-communication';
import { useIntl } from 'common/config/i18n';

import { TargetDVNumbersProps } from './utils';

const { TextArea } = Input;

const TargetDVNumbers = ({ formik, httpErrorMessage, handleChangeDvNumbers }: TargetDVNumbersProps) => {
  const { theme } = useTheme();
  const { t } = useIntl();
  const [errorMessage, setErrorMessage] = useState<string>('');

  useEffect(() => {
    if (httpErrorMessage) {
      setErrorMessage(httpErrorMessage);
    }
  }, [httpErrorMessage]);

  const handleBlur = () => {
    const { DVNumbers } = formik.values;
    const { errorMessage, hasError } = processAndValidateUnitElements(DVNumbers || '', t);

    if (hasError) {
      /**
       * The error message displayed to the user is managed and customized using errorMessage
       * And we need to set the formik error too in order to disable the 'Continue' button and prevent the user from submitting the form
       */
      formik
        .setTouched({
          ...formik.touched,
          DVNumbers: true,
        })
        .then(() => {
          formik.setErrors({
            ...formik.errors,
            DVNumbers:
              'The processing and validation of DVNumbers did not succeed in the processAndValidateUnitElements function.',
          });
        });
      setErrorMessage(errorMessage);
    }
  };

  const handleFocus = () => {
    setErrorMessage('');
  };

  return (
    <>
      <TextArea
        name="DVNumbers"
        autoSize={{ minRows: 5 }}
        onChange={handleChangeDvNumbers}
        onBlur={handleBlur}
        onFocus={handleFocus}
        value={formik.values.DVNumbers}
        style={
          Object.keys(formik.touched).length !== 0 && formik.errors.DVNumbers
            ? { borderColor: theme.colors.orange.main }
            : {}
        }
      />
      {errorMessage ? (
        <FormError formik={formik} message={errorMessage} />
      ) : (
        <FormError formik={formik} fieldName="DVNumbers" />
      )}
    </>
  );
};

export default TargetDVNumbers;
